import { styled } from '@mui/material/styles'

export const ErrorMessage = styled('span')`
  color: red;
`
